import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

/**
 * Locale-aware navigation. `Link` takes an un-prefixed href ("/standings")
 * and renders it under the current locale ("/es/standings"), so components
 * never build locale prefixes by hand. `usePathname` returns the path WITHOUT
 * the prefix, which is what the switcher and analytics want.
 */
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
